import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import { postData } from "../../../backend/api";
import AutoForm from "../../elements/form";
import Footer from "../footer/index2";
import { FormContainer, MainContainer, SignUpLink } from "./styles";
//using translation
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import withLayout from "../layout";
import { ColumnContainer } from "../../styles/containers/styles";
import Header from "../header";
import { clearLoginSession, fetchLogin } from "../../../store/actions/login";
import LanguageTooltip from "../../elements/tooltip";

const SignUpPageLink = ()=>{
  const { t } = useTranslation();
  return(
    <SignUpLink>
      {t("Don't have an account?")} <Link style={{color:'#15629A'}} to="/sign-up">{t('Sign Up')}</Link>
    </SignUpLink>
  )
}

const ForgetPassword = ()=>{
  const { t } = useTranslation();
  return(<Link style={{color:'#15629A',textDecoration:'none'}} to="/forget-password">{t('Forget Password')}</Link>
  )
}

const Login = (props) => {
  useEffect(() => {
    document.title = `Time Recording Tool`;
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const { t } = useTranslation();
  const [formInput] = useState([
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      minimum: 5,
      maximum: 40,
      required: true,
    },
    {
      type: "password",
      placeholder: "password",
      name: "password",
      validation: "password",
      default: "",
      label: "password",
      minimum: 6,
      maximum: 16,
      required: true,
    },
    // {
    //   type: "checkbox",
    //   placeholder: "Remember me",
    //   name: "rememberMe",
    //   validation: "rememberMe",
    //   default: "",
    //   label: "Remember me",
    // },
  ]);
  const { setLoaderBox } = props;
  useEffect(() => {
    if (user.data?.token) {
      navigate(user.data?.menu[0]?.path ?? "dashboard");
    }
    setLoaderBox(user.isLoading);
    if (user.error !== null) {
      props.setMessage({ type: 1, content: t(user.error), proceed: "Okay", code: 400 });
      dispatch(clearLoginSession());
    }
  }, [user, navigate, setLoaderBox, t, props, dispatch]);

  const isCreatingHandler = (value, callback) => {};
  const submitChange = async (post) => {
    dispatch(fetchLogin(post));
  };

  return (
    <MainContainer>
      {/* <Header> </Header> */}
      <ColumnContainer className="login">
        <FormContainer className="login">
          <AutoForm enterSubmit={true} useCaptcha={false} formType={"post"} description={t("loginDescription")} header={t("loginHead")} formInput={formInput} submitHandler={submitChange} button={t("validate")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={true} ForgetPassword={ForgetPassword} login={"loginForm"}></AutoForm>
          <div style={{marginTop:'10px',width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <LanguageTooltip page={"login"} />
          </div>
          <SignUpLink>
            {t("Don't have an account?")} <Link to="/sign-up">{t('Start now')}</Link>
          </SignUpLink>
        </FormContainer>

      </ColumnContainer>
      <Footer></Footer>
    </MainContainer>
  );
};

export default withLayout(Login);
